"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaGraph = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var recharts_1 = require("recharts");
require("./areaGraph.css");
var AreaGraph = function (_a) {
    var width = _a.width, height = _a.height, data = _a.data, areaThemes = _a.areaThemes, _b = _a.theme, theme = _b === void 0 ? {
        hideXAxisTick: false,
    } : _b, _c = _a.legendPosition, legendPosition = _c === void 0 ? {
        layoutDirection: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
    } : _c, customTooltip = _a.customTooltip;
    var renderGradients = function () {
        return Object.keys(areaThemes)
            .filter(function (k) { return data[0][k] !== null; })
            .map(function (k) {
            var area = areaThemes[k];
            return ((0, jsx_runtime_1.jsxs)("linearGradient", __assign({ id: "gradient-".concat(area.slug), x1: "0", y1: "0", x2: "0", y2: "1" }, { children: [(0, jsx_runtime_1.jsx)("stop", { offset: "15%", stopColor: area.hexColor, stopOpacity: 0.4 }), (0, jsx_runtime_1.jsx)("stop", { offset: "100%", stopColor: area.hexColor, stopOpacity: 0.1 })] }), "gradient-".concat(area.slug)));
        });
    };
    var renderAreaChart = function () {
        return Object.keys(areaThemes)
            .filter(function (k) { return data[0][k] !== null; })
            .map(function (k) {
            var area = areaThemes[k];
            return ((0, jsx_runtime_1.jsx)(recharts_1.Area, { name: area.areaName, dataKey: k, type: "monotone", dot: area.dot, strokeWidth: "3px", stroke: area.hexColor, fill: "url(#gradient-".concat(area.slug, ")"), fillOpacity: 1 }, "area-".concat(area.slug)));
        });
    };
    var renderLegend = function () {
        return Object.keys(areaThemes).filter(function (k) { return data[0][k] !== null; }).length > 1 ? ((0, jsx_runtime_1.jsx)(recharts_1.Legend, { wrapperStyle: legendPosition.layoutDirection === 'vertical' ? { maxWidth: '40%' } : {}, layout: legendPosition.layoutDirection, verticalAlign: legendPosition.verticalAlign, align: legendPosition.align, iconType: "circle", iconSize: 10 })) : null;
    };
    var greyStroke = '#BDBDBD';
    return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ width: width, height: height, className: "area-graph" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.AreaChart, __assign({ data: data, margin: {
                top: 30,
                right: 30,
                left: 0,
                bottom: 0,
            } }, { children: [(0, jsx_runtime_1.jsx)("defs", { children: renderGradients() }), (0, jsx_runtime_1.jsx)(recharts_1.XAxis, __assign({ tick: theme.hideXAxisTick, stroke: greyStroke, tickSize: 0, axisLine: false, dataKey: "xLabel", interval: theme.xAxisInterval }, ((theme === null || theme === void 0 ? void 0 : theme.xAxisAngle)
                    ? {
                        height: 48,
                        tickMargin: 22,
                        angle: theme.xAxisAngle,
                    }
                    : {
                        tickMargin: 13,
                    }))), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, { stroke: greyStroke, width: 70, tickMargin: 10, tickSize: 0, axisLine: false, unit: theme === null || theme === void 0 ? void 0 : theme.yAxisUnit }), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, __assign({}, (customTooltip ? { content: customTooltip } : {}))), (theme === null || theme === void 0 ? void 0 : theme.gridStroke) && ((0, jsx_runtime_1.jsx)(recharts_1.CartesianGrid, { stroke: "#F5F5F5", strokeDasharray: theme === null || theme === void 0 ? void 0 : theme.gridStroke, vertical: false })), renderLegend(), renderAreaChart()] })) })));
};
exports.AreaGraph = AreaGraph;
//# sourceMappingURL=AreaGraph.js.map